<app-modal
  class="error-container"
  [(visible)]="visible"
  [foreground]="false"
  (onHide)="clearErrors()"
  header="You have the following error(s) with your submission:">

  <div class="error-message" *ngFor="let error of errors; trackBy: trackByIndex">{{ getDisplayText(error) }}</div>

</app-modal>